"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQuoteGrid = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var quotetable_1 = require("../quotetable");
require("./page.less");
var qihuo_grid_1 = require("./qihuo_grid");
/**
 * 简单行情表格页面
 * @returns
 */
function PageQuoteGrid() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash_no_sharp = location.hash;
    if (hash_no_sharp.substring(0, 1) == '#') {
        hash_no_sharp = hash_no_sharp.substring(1);
    }
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
    }, [hash_no_sharp]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(qihuo_grid_1.ShowCrumbsWithRefreshLine, null),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageQuoteGrid = PageQuoteGrid;
